/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeValidationRpc
 */

export const LandingPageCoordinatesTypename = 'com.hubspot.personalize.models.LandingPageCoordinates';
export const WebInteractiveCoordinatesTypename = 'com.hubspot.personalize.models.WebInteractiveCoordinates';
export const WebsitePageCoordinatesTypename = 'com.hubspot.personalize.models.WebsitePageCoordinates';
export const validatePersonalizationPrerequisitesRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeValidationRpc',
  rpcName: 'validatePersonalizationPrerequisites',
  auth: 'app',
  fingerprint: 'G_Uux5hHXeQa-hlbykpiYzCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};